const ttl = (value) => {
  const ttl = parseInt(value, 10);
  if (!Number.isInteger(ttl) || ttl < 0 || ttl > 2147483647)
    return "validate.ttl_failed";
  return true;
};

export { ttl };
